import React from 'react';
import PropTypes from 'prop-types';
import BooleanAnswerOptions from './BooleanAnswerOptions';
import ScaleAnswerOptions from './ScaleAnswerOptions';
import DualScaleAnswerOptions from './DualScaleAnswerOptions';
import MultipleChoiceAnswerOptions from './MultipleChoiceAnswerOptions';

const QuizAnswerOptions = ({
    answerType,
    booleanSettings,
    scaleSettings,
    dualScaleSettings,
    multipleChoiceSettings,
    selectedAnswer,
    onAnswer,
}) => {
    switch (answerType) {
        case 'boolean':
            return (
                <BooleanAnswerOptions
                    optionA={booleanSettings?.optionA || 'Option A'}
                    optionB={booleanSettings?.optionB || 'Option B'}
                    selectedAnswer={selectedAnswer}
                    onAnswer={onAnswer}
                />
            );

        case 'scale':
            return (
                <ScaleAnswerOptions
                    scaleLabelLow={scaleSettings?.scaleLabelLow || 'Low'}
                    scaleLabelHigh={scaleSettings?.scaleLabelHigh || 'High'}
                    selectedAnswer={selectedAnswer}
                    onAnswer={onAnswer}
                />
            );

        case 'dual_scale':
            return (
                <DualScaleAnswerOptions
                    leftLabel={dualScaleSettings?.leftLabel || 'Left'}
                    rightLabel={dualScaleSettings?.rightLabel || 'Right'}
                    selectedAnswer={selectedAnswer}
                    onAnswer={onAnswer}
                />
            );

        case 'multiple_choice':
            return (
                <MultipleChoiceAnswerOptions
                    choices={multipleChoiceSettings?.choices || []}
                    allowMultipleSelection={multipleChoiceSettings?.allowMultipleSelection || false}
                    selectedAnswer={selectedAnswer}
                    onAnswer={onAnswer}
                />
            );

        default:
            console.warn(`⚠️ Unhandled quiz answer type: ${answerType}`);
            return null;
    }
};

QuizAnswerOptions.propTypes = {
    answerType: PropTypes.string.isRequired,
    booleanSettings: PropTypes.shape({
        optionA: PropTypes.string,
        optionB: PropTypes.string,
    }),
    scaleSettings: PropTypes.shape({
        scaleLabelLow: PropTypes.string,
        scaleLabelHigh: PropTypes.string,
    }),
    dualScaleSettings: PropTypes.shape({
        leftLabel: PropTypes.string,
        rightLabel: PropTypes.string,
    }),
    multipleChoiceSettings: PropTypes.shape({
        choices: PropTypes.arrayOf(PropTypes.string),
        allowMultipleSelection: PropTypes.bool,
    }),
    selectedAnswer: PropTypes.any,
    onAnswer: PropTypes.func.isRequired,
};

export default QuizAnswerOptions;
